var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"fadein":"","title":false,"width":"auto","button":false}},[(_vm.video)?_c('video',{staticClass:"video",attrs:{"src":_vm.src,"loop":"","autoplay":""}}):_c('img',{ref:"img",staticClass:"preview",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }